// import { StateReducers } from 'state/reducers/types/StateReducers'

import {
  // RemoveTagButtonConnectedProps,
  RemoveTagButtonMapStateReturnType,
} from './types'

export const RemoveTagButtonMapState = (): // state: StateReducers,
// props: RemoveTagButtonConnectedProps,
RemoveTagButtonMapStateReturnType => {
  // const currentLocation = state.currentLocation || undefined
  // const isRoutes = currentLocation && currentLocation.isRoutes
  // return { isRoutes }

  return {}
}
